/**
 * Service (diagnostics/procedure) requests (M11, ADR-0025). A service is "just a
 * form": pick a procedure + provider (known price), schedule a slot, submit. The
 * request is created in `pending_payment` (payment is Stage 2). Authed via the
 * in-memory patient session (ADR-0021).
 */
import { apiFetch } from '../lib/api'

export type ServiceRequestCreated = {
  reference: string
  status: string
  hospital_name: string
  procedure_name: string
  price_pesewas: number
  commission_pesewas: number
  provider_pesewas: number
  currency: string
  scheduled_for: string
  hold_expires_at: string
}

/** POST /api/v1/patient/service-requests (authed). Throws `ApiError`
 * (`not_found` 404, `not_bookable` 409, `invalid_slot` 422). */
export async function createServiceRequest(
  token: string,
  input: {
    hospitalSlug: string
    procedureSlug: string
    scheduledFor: string // ISO 8601
    patientName?: string
    notes?: string
  },
): Promise<ServiceRequestCreated> {
  const body: Record<string, string> = {
    hospital_slug: input.hospitalSlug,
    procedure_slug: input.procedureSlug,
    scheduled_for: input.scheduledFor,
  }
  if (input.patientName) body.patient_name = input.patientName
  if (input.notes) body.notes = input.notes

  const res = await apiFetch<{ data: ServiceRequestCreated }>(
    '/api/v1/patient/service-requests',
    { method: 'POST', token, body },
  )
  return res.data
}
